import '@babel/polyfill/noConflict';
import './vendor/modernizr';

import GoogleMapsApiLoader from 'google-maps-api-loader';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';
import { Carousel } from './lib/carousel';
import { Maps } from './lib/maps';
import { Sticky } from './lib/sticky';
import { Trigger } from './lib/trigger';
import { Popup } from './lib/popup';
// import { LazyLoad } from './lib/lazy-load';

objectFitImages();

const animate = new AnimateObserver();
animate.init();

const carousel = new Carousel();
carousel.init();

const sticky = new Sticky();
sticky.init();

const popup = new Popup();
popup.init();

const trigger = new Trigger();
trigger.init();

// const lazy = new LazyLoad();
// lazy.init();

const maps = new Maps();
maps.init();

GoogleMapsApiLoader( {
    libraries: [],
    apiKey: 'AIzaSyD_o7zIcKpCSZ0ZGtr5u6_aUxAARJBR26U'
} ).then( googleApi => {
    maps.generate( googleApi );
} );

